var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { TextField } from '@mui/material';
function NumericTextField(props) {
    var value = props.value, onChange = props.onChange, inputProps = props.inputProps;
    var handleChange = React.useCallback(function (event) {
        if (!event.target.value)
            return onChange(event.target.value);
        var strValue = event.target.value || '0';
        if (inputProps === null || inputProps === void 0 ? void 0 : inputProps.maxLength) {
            strValue =
                event.target.value.length > inputProps.maxLength
                    ? event.target.value.substr(0, inputProps.maxLength)
                    : event.target.value;
        }
        var value = parseFloat(strValue || '0');
        if ((inputProps === null || inputProps === void 0 ? void 0 : inputProps.min) !== undefined) {
            if (value < inputProps.min) {
                value = inputProps.min;
            }
        }
        if (inputProps === null || inputProps === void 0 ? void 0 : inputProps.max) {
            if (value > inputProps.max) {
                value = inputProps.max;
            }
        }
        onChange(value);
    }, [onChange, inputProps]);
    var label = React.useMemo(function () {
        var title = props.columnDef.title;
        return typeof title === 'string' ? title : '';
    }, [props]);
    return (React.createElement(TextField, { fullWidth: true, style: { float: 'right' }, type: "number", placeholder: label, value: value, onChange: handleChange, InputProps: {
            style: {
                fontSize: 13,
            },
        }, inputProps: __assign({ 'aria-label': label, style: {
                textAlign: 'right',
            } }, inputProps) }));
}
export default NumericTextField;
